import Carrocel from "./Carrocel"

const FestasShows = (props) => {
  const guposCategoria = [
    {grupo: 'Open Bar', categorias: ['Open Bar']},
    {grupo: 'Pop ou Funk', categorias: ['Pop', 'Funk']},
    {grupo: 'Festas Picantes', categorias: ['XXX']},
    {grupo: 'Eletrônica ou Trance', categorias: ['Eletrônica', 'Trance']},
    {grupo: 'Reggae, Reggaeton ou Hip-Hop', categorias: ['Reggae', 'Reggaeton', 'Hip-Hop']},
    {grupo: 'Samba, Pagode, Sertanejo ou Forró', categorias: ['Samba', 'Pagode', 'Sertanejo', 'Forró']},
    {grupo: 'MPB, Jazz, Rock ou Karaokê', categorias: ['MPB', 'Jazz', 'Rock', 'Karaokê']},
    {grupo: 'Outros', categorias: ["[]"]}
  ]

  return(
    <div className="items-center w-screen text-xl pt-3 justify-between md:text-base gap-8">
      <div className='flex justify-center pb-10'>{props.eventosFiltrado.length} Rolês encontrados.</div>
      {guposCategoria.map(item => {
        const roles = props.eventosFiltrado.filter(elememento => item.categorias.some(categoria => elememento.subcategoria.includes(categoria)))
        
        if(roles.length > 0) return(
          <div className='mb-16'>
            <div className='ml-14 mb-4 text-2xl font-semibold max-w-[72vw]'>{item.grupo}</div>
            <Carrocel roles={roles} locais={props.locais} selectData={props.selectData} selectValor={props.selectValor} />
          </div>
        ) 
      })}          
    </div>
  )
}

export default FestasShows